// eslint-disable-next-line @typescript-eslint/no-unused-vars
import React from 'react';
import { Link } from 'react-router-dom';
import { roomsData } from '../data/roomsData';
import { Users, Bath, Maximize, Coffee, Wifi, Check } from 'lucide-react';

const RoomsPage: React.FC = () => {
  const filteredRooms = roomsData;

  return (
      <div>
        {/* Hero Section */}
        <section className="h-[40vh] relative flex items-center justify-center">
          <div
              className="absolute inset-0 bg-cover bg-center bg-no-repeat"
              style={{
                backgroundImage: 'url("/uploads/WhatsApp Image 2025-05-09 at 09.16.37.jpeg")',
              }}
          >
            <div className="absolute inset-0 bg-black opacity-40"></div>
          </div>

          <div className="container mx-auto px-4 md:px-6 relative z-10 text-center">
            <h1 className="text-4xl md:text-5xl font-serif font-bold text-white mb-4">
              Camerele Noastre
            </h1>
            <p className="text-xl text-white mb-0 max-w-2xl mx-auto">
              Confort și relaxare pentru sejurul dumneavoastră
            </p>
          </div>
        </section>

        {/* Rooms Listing */}
        <section className="py-16 bg-sage-50">
          <div className="container mx-auto px-4 md:px-6">
            {/* Rooms Grid */}
            <div className="grid grid-cols-1 gap-8">
              {filteredRooms.map((room) => (
                  <div
                      key={room.id}
                      className="bg-white rounded-lg overflow-hidden shadow-lg transition-all hover:-translate-y-1 hover:shadow-xl"
                  >
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                      <div className="relative overflow-hidden group">
                        <img
                            src={room.images[0]}
                            alt={room.name}
                            className="w-full h-[400px] object-cover transition-transform duration-500 group-hover:scale-110"
                        />
                        <div className="absolute top-4 right-4 bg-white px-3 py-1 rounded-full text-sage-700 font-medium shadow">
                          {room.price} lei/noapte
                        </div>
                      </div>
                      <div className="p-6">
                        <h3 className="text-2xl font-bold text-gray-800 mb-4">{room.name}</h3>
                        <p className="text-gray-600 mb-6">{room.description}</p>

                        <div className="grid grid-cols-2 gap-4 mb-6">
                          <div className="flex items-center text-gray-600">
                            <Users className="h-5 w-5 mr-2" />
                            <span>{room.capacity} Oaspeți</span>
                          </div>
                          <div className="flex items-center text-gray-600">
                            <Maximize className="h-5 w-5 mr-2" />
                            <span>{room.size} m²</span>
                          </div>
                          <div className="flex items-center text-gray-600">
                            <Bath className="h-5 w-5 mr-2" />
                            <span>{room.bathroom}</span>
                          </div>
                          <div className="flex items-center text-gray-600">
                            <Wifi className="h-5 w-5 mr-2" />
                            <span>WiFi Gratuit</span>
                          </div>
                        </div>

                        <div className="flex justify-between items-center">
                          <Link
                              to={`/rooms/${room.id}`}
                              className="text-sage-700 hover:text-sage-800 font-medium"
                          >
                            Vezi Detalii
                          </Link>
                          <Link
                              to={`/book?room=${room.id}`}
                              className="bg-sage-700 hover:bg-sage-800 text-white px-6 py-3 rounded-md transition-colors"
                          >
                            Rezervă Acum
                          </Link>
                        </div>
                      </div>
                    </div>

                    {/* Additional Images */}
                    <div className="p-6 border-t border-gray-200">
                      <h4 className="text-lg font-bold text-gray-800 mb-4">Mai multe imagini</h4>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                        {room.images.slice(1).map((image, index) => (
                            <div key={index} className="relative aspect-[4/3] overflow-hidden rounded-lg">
                              <img
                                  src={image}
                                  alt={`${room.name} - Imagine ${index + 2}`}
                                  className="w-full h-full object-cover hover:scale-110 transition-transform duration-300"
                              />
                            </div>
                        ))}
                      </div>
                    </div>
                  </div>
              ))}
            </div>
          </div>
        </section>

        {/* Amenities */}
        <section className="py-16 bg-white">
          <div className="container mx-auto px-4 md:px-6">
            <div className="text-center mb-12">
              <h2 className="text-3xl font-serif font-bold text-gray-800 mb-3">
                Facilități Incluse
              </h2>
              <p className="text-gray-600 max-w-2xl mx-auto">
                Camera noastră vine cu toate aceste facilități pentru confortul dumneavoastră.
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-8">
              {[
                { icon: <Wifi className="h-8 w-8 text-sage-600 mb-2" />, label: "WiFi Gratuit" },
                { icon: <Coffee className="h-8 w-8 text-sage-600 mb-2" />, label: "Cafea din partea casei" },
                { icon: <Check className="h-8 w-8 text-sage-600 mb-2" />, label: "Curățenie Zilnică" },
                { icon: <Check className="h-8 w-8 text-sage-600 mb-2" />, label: "Aer Condiționat" },
                { icon: <Check className="h-8 w-8 text-sage-600 mb-2" />, label: "TV cu Ecran Plat" },
              ].map((amenity, index) => (
                  <div key={index} className="text-center">
                    <div className="flex justify-center">
                      {amenity.icon}
                    </div>
                    <p className="text-gray-700 font-medium">{amenity.label}</p>
                  </div>
              ))}
            </div>
          </div>
        </section>

        {/* CTA */}
        <section className="py-16 bg-sage-700 text-white">
          <div className="container mx-auto px-4 md:px-6 text-center">
            <h2 className="text-3xl font-serif font-bold mb-4">
              Gata să Rezervați?
            </h2>
            <p className="text-xl max-w-2xl mx-auto mb-8 text-sage-100">
              Rezervați acum pentru a vă asigura datele preferate.
            </p>
            <Link
                to="/book"
                className="px-8 py-3 bg-white text-sage-700 hover:bg-sage-100 rounded-md transition-colors shadow-lg text-lg font-medium inline-block"
            >
              Faceți o Rezervare
            </Link>
          </div>
        </section>
      </div>
  );
};

export default RoomsPage;